import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
const TiktokIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-66" data-mp="16xy203r3upfu">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-67" data-mp="1fz5vm8iof23l" />
  </svg>;
const LINKS = [{
  label: 'tour',
  href: '#tour'
}, {
  label: 'Music',
  href: '#music'
}, {
  label: 'Videos',
  href: '#videos'
}, {
  label: 'Merch',
  href: '#merch'
}];
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.header initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-brand-black/80 backdrop-blur-md border-b border-brand-white/5' : 'bg-transparent'}`} data-id="element-68" data-mp="1u4d1hbf5rw9c">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between" data-id="element-69" data-mp="2cuuvdjbq8xwa">
          {/* Brand / Home */}
          <a href="#" aria-label="RuslanSilvr — Home" className="font-display text-xl md:text-2xl tracking-widest uppercase text-brand-white hover:text-brand-accent transition-colors" data-id="element-70" data-mp="28330iwljg60c">
            RuslanSilvr
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-71" data-mp="2vsnu09fbilnv">
            {LINKS.map(link => <a key={link.label} href={link.href} className="text-sm font-medium tracking-widest uppercase text-brand-muted hover:text-brand-white transition-colors" data-id="element-72" data-mp="tx81mv7of1vy">
                {link.label}
              </a>)}
          </nav>

          <div className="hidden md:flex items-center gap-4" data-id="element-73" data-mp="p45cr0duggm3">
            <a href="https://www.instagram.com/ruslansilvr/" target="_blank" rel="noopener noreferrer" className="text-brand-muted hover:text-brand-accent transition-colors" data-id="element-74" data-mp="a7o4ii0ybi3r">
              <InstagramIcon className="w-5 h-5" data-id="element-75" data-mp="192e60p8mysf" />
            </a>
            <a href="https://www.tiktok.com/@ruslansilvr?lang=en" target="_blank" rel="noopener noreferrer" className="text-brand-muted hover:text-brand-accent transition-colors" data-id="element-76" data-mp="65stglt7xqcs">
              <TiktokIcon className="w-5 h-5" data-id="element-77" data-mp="20iiwpu5h8bwu" />
            </a>
            <a href="https://www.youtube.com/@ruslansilvr" target="_blank" rel="noopener noreferrer" className="text-brand-muted hover:text-brand-accent transition-colors" data-id="element-78" data-mp="2aplgmd6n1qe4">
              <YoutubeIcon className="w-5 h-5" data-id="element-79" data-mp="2jiouunp3y79t" />
            </a>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden text-brand-white p-2 -mr-2" onClick={() => setIsOpen(true)} data-id="element-80" data-mp="2tf1l1blg22zt">
            <MenuIcon className="w-6 h-6" data-id="element-81" data-mp="2oevqnnnsi2e1" />
          </button>
        </div>
      </motion.header>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-82" data-mp="32f6jgw8ntr1u">
        {isOpen && <motion.div initial={{
        opacity: 0,
        clipPath: 'inset(0 0 100% 0)'
      }} animate={{
        opacity: 1,
        clipPath: 'inset(0 0 0% 0)'
      }} exit={{
        opacity: 0,
        clipPath: 'inset(0 0 100% 0)'
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed inset-0 z-50 bg-brand-black flex flex-col" data-id="element-83" data-mp="2yee9u1vvlk51">
            <div className="px-6 h-20 flex items-center justify-between border-b border-brand-white/10" data-id="element-84" data-mp="1ej8oglsdqsuw">
              <a href="#" onClick={() => setIsOpen(false)} aria-label="RuslanSilvr — Home" className="font-display text-2xl tracking-widest uppercase text-brand-white hover:text-brand-accent transition-colors" data-id="element-85" data-mp="1jgicpy418yh5">
                RuslanSilvr
              </a>
              <button onClick={() => setIsOpen(false)} className="text-brand-white p-2 -mr-2" data-id="element-86" data-mp="vpmr5iq66zic">
                <XIcon className="w-6 h-6" data-id="element-87" data-mp="31qvmhcc7dn5" />
              </button>
            </div>
            <div className="flex-1 flex flex-col items-center justify-center gap-8" data-id="element-88" data-mp="81daswbq73yl">
              {LINKS.map((link, i) => <motion.a key={link.label} href={link.href} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1 * i,
            duration: 0.5
          }} onClick={() => setIsOpen(false)} className="font-display text-4xl tracking-widest uppercase text-brand-white hover:text-brand-accent transition-colors" data-id="element-89" data-mp="h1aww9t74u5" data-mpi={i}>
                  {link.label}
                </motion.a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}